let appid = '' // appid
let openid = '' // openid
let headPortrait = '' // 头像
let nickname = '' // 昵称
let usertel = '' // 用户绑定手机号
let villageName = '请选择小区' // 小区名
let villageId = '' // 小区id
let villageStatus = 0 // 小区默认选中状态
let repairId = '' // 报修id
let memberId = '' // tob后台用户id
let userId = '' // 员工id
let roomId = '' // 报修绑定房屋id
let roomName = '' // 报修绑定房屋名
let lng = '' // 获取当前经度
let lat = '' // 获取当前纬度
let orderTime = '' // 报修选择的预约时间
let appointTime = '' // 指定时间
let setTime = '' // 后台设定指定时间
let warningTime = '' // 后台设定预警时间
let permission = '' // 权限判断 1.repair_keeper 员工  2.repair_leader 主管 3.repair_leader_keeper 主管/员工 4.administrators 超管 5.等于空什么也看不到
let permissionSign = '' // 权限标识
let wechatRemind = 0 // 通知状态
let locationRange = '' // 打卡范围
export default {
  appid,
  openid,
  headPortrait,
  nickname,
  usertel,
  villageName,
  villageId,
  villageStatus,
  repairId,
  memberId,
  userId,
  roomId,
  roomName,
  lng,
  lat,
  appointTime,
  setTime,
  warningTime,
  orderTime,
  permission,
  permissionSign,
  wechatRemind,
  locationRange
}



// WEBPACK FOOTER //
// ./src/store/state.js